export default __webpack_public_path__ + "locales/fi/People.json?hash=d82cc70c9c5cc32fb66bbeccce4f6e99";